import { useEffect, useState } from 'react';
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody
} from 'reactstrap';
import { useNavigate } from "react-router-dom";
import AssignmentIcon from '@mui/icons-material/Assignment';
import DesignServicesIcon from '@mui/icons-material/DesignServices';
import ArchitectureIcon from '@mui/icons-material/Architecture';
import ElectricalServicesIcon from '@mui/icons-material/ElectricalServices';
import { useAuth } from '../../Context/AuthContext';
import { getUserProfile } from '../../Api/ApiUrlConst';

interface UserProfileDTO {
  name: string;
  email: string;
  role: string;
  department: string;
  gender: string;
  phoneNumber: string;
}

function Home() {
  const { role } = useAuth();

  const navigate = useNavigate();
  const [cadModalOpen, setCadModalOpen] = useState(false);

  const toggleCadModal = () => setCadModalOpen(!cadModalOpen);


  return (
    <>
      <Container fluid className="dash-card mt-5">

        <Row className="text-center g-4 justify-content-center mb-4">
          {/* TASK CARD */}
          <Col md={5}>
            <Card
              className="shadow border-0 rounded-4 h-100 transition-hover"
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/login")}
            >
              <CardBody className="py-5">
                <div className="mb-3 text-warning">
                  <AssignmentIcon sx={{ fontSize: 50 }} />
                </div>
                <h5 className="fw-bold mb-2">Task Manager</h5>
                {/* <p className="text-muted">
    Plan, assign, and track tasks and subtasks efficiently.
    Stay on schedule with clear ownership, priorities, and progress tracking.
  </p> */}
                <p className="text-muted">
                  Streamline project execution through structured task planning,
                  real-time tracking, and accountability across teams.
                </p>

              </CardBody>

            </Card>
          </Col>

          {/* SOLIDWORKS */}
          <Col md={5}>
            <Card
              className="shadow border-0 rounded-4 h-100 transition-hover cursor-pointer"

              style={{ cursor: "pointer" }}
              onClick={() => window.open('https://solidworks.appspro.in/', '_blank')}
            >
              <CardBody className="py-5">
                <div className="mb-3 text-success">
                  <DesignServicesIcon sx={{ fontSize: 50 }} />
                </div>
                <h5 className="fw-bold mb-2">Solid Works</h5>
                <p className="text-muted mb-1">solidworks.apppro.in</p>
                <p className="text-muted">
                  Build powerful mechanical designs with cloud-based SolidWorks tools.
                  View 2D drawings and 3D models instantly without installation.
                  Export designs safely in PDF, STL, and STEP formats.
                </p>

              </CardBody>

            </Card>
          </Col>
        </Row>


        <Row className="text-center g-4 justify-content-center">
          {/* INVENTOR */}
          <Col md={5}>
            <Card
              className="shadow border-0 rounded-4 h-100 transition-hover cursor-pointer "

              style={{ cursor: "pointer" }}
              onClick={() => window.open('https://inventor.appspro.in', '_blank')}
            >
              <CardBody className="py-5">
                <div className="mb-3 text-danger">
                  <ArchitectureIcon sx={{ fontSize: 50 }} />
                </div>
                <h5 className="fw-bold mb-2">Autodesk Inventor</h5>
                <p className="text-muted mb-1">inventor.appspro.in</p>
                <p className="text-muted">
                  Design and configure products from anywhere in the world.
                  Create and preview 2D drawings and interactive 3D models directly in your browser.
                  Securely download files in PDF, STL, and IPT formats.
                </p>

              </CardBody>

            </Card>
          </Col>
          {/* NX */}
          <Col md={5}>
            <Card
              className="shadow border-0 rounded-4 h-100 transition-hover cursor-pointer"

            >
              <CardBody className="py-5">
                <div className="mb-3 text-info">
                  <ArchitectureIcon sx={{ fontSize: 50 }} />

                </div>
                <h5 className="fw-bold mb-2">NX</h5>
                <p className="text-muted mb-1">NX.appspro.in</p>
                <p className="text-muted">
                  Advanced product design and engineering tools.
                  Browser-based access for next-gen CAD workflows.
                </p>
              </CardBody>

            </Card>

          </Col>

        </Row>

      </Container>
    </>
  );
}

export default Home;